/* eslint-disable no-underscore-dangle, no-console */

// TypeScript declarations for Whatfix global state
declare global {
  interface Window {
    _whatfixLoading?: boolean;
    _whatfixLoaded?: boolean;
  }
}

export const loadWhatfixScript = (scriptUrl: string, timeout?: number) => {
  // Don't load in iframe/embedded contexts
  if (window.frameElement && window.frameElement.id === 'embed') {
    return;
  }

  // Check if script already exists OR is currently loading
  const existingScript = document.querySelector('script[src*="whatfix.com"]');
  if (existingScript || window._whatfixLoading || window._whatfixLoaded) {
    return;
  }

  // Mark as loading to prevent duplicate attempts
  window._whatfixLoading = true;

  const script = document.createElement('script');
  script.async = true;
  script.type = 'text/javascript';
  script.src = scriptUrl;

  // Use provided timeout or default to 10 seconds
  const timeoutDuration = timeout && timeout > 0 ? timeout : 10000;

  const timeoutId = setTimeout(() => {
    console.warn(`Whatfix script is taking longer than expected to load (>${timeoutDuration}ms)`);
  }, timeoutDuration);

  script.onload = () => {
    clearTimeout(timeoutId);
    window._whatfixLoading = false;
    window._whatfixLoaded = true;
    console.log('Whatfix loaded successfully');
  };

  script.onerror = () => {
    clearTimeout(timeoutId);
    window._whatfixLoading = false;
    console.warn('Whatfix failed to load.');
  };

  document.head.appendChild(script);
};

// Cleanup Whatfix script and reset global state on component unmount
export const cleanupWhatfixScript = () => {
  const script = document.querySelector('script[src*="whatfix.com"]');
  if (script) {
    script.remove();
  }

  if (window._whatfixLoading !== undefined) {
    window._whatfixLoading = false;
  }
  if (window._whatfixLoaded !== undefined) {
    window._whatfixLoaded = false;
  }
};

/* eslint-enable no-underscore-dangle, no-console */
